import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const ImageFileIcon = createSvgIcon(
  <g>
    <rect x="8" y="10" width="48" height="44" rx="8" fill="#7C3AED" />
    <circle cx="22" cy="24" r="5" fill="#FDE68A" />
    <path d="M12 48l13-16 8 10 7-9 12 15H12z" fill="#FFFFFF" opacity="0.95" />
  </g>,
  'ImageFileIcon',
);
